import { GLOBAL_HD_DTU_ID } from './common';

export const checkIsGlobalHDDtu = (datasetId: string) => datasetId.includes(GLOBAL_HD_DTU_ID);

/**
 * Global-HD-DTU and Global-HD-CMEMS-ReA-DTU are live tide predictions generated
 * on demand by the backend's tide-prediction pipeline (DtuExtractionStrategy /
 * CmemsExtractionStrategy), which already extends EndDate to the end of the day
 * itself. Padding EndDate to 23:59 here too would double that up and over-fetch
 * an extra day of predictions.
 */
export const isUsingBackendManagedEndOfDay = (datasetId: string) =>
  checkIsGlobalHDDtu(datasetId) || datasetId.includes('CMEMS');
